import React, { useState, useEffect } from 'react';

const ImageCarousel = ({ projectId }) => {
    const [images, setImages] = useState([]);
    const [highResImages, setHighResImages] = useState([]);
    const [fileIds, setFileIds] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState('thumbnail'); 
    
    const getDirectDownloadUrl = (fileId) => {
        return `https://lh3.google.com/u/0/d/${fileId}`
    };

    const getThumbnailUrl = (fileId) => {
        return `https://drive.google.com/thumbnail?id=${fileId}&sz=w300`;
    };

    useEffect(() => {
        const loadImages = async () => {
            try {
                const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
                
                if (!apiKey) {
                    throw new Error("Google API key not found in environment variables");
                }

                let folderId = "1kLdnnm47c7GkmKgiyIbv2QXh7sqFZ6p4";
                
                let query = encodeURIComponent(`'${folderId}' in parents and trashed=false`);

                let driveResponse = await fetch(
                    `https://www.googleapis.com/drive/v3/files?q=${query}&fields=files(id,name,mimeType)&key=${apiKey}`
                );
                
                if (!driveResponse.ok) {
                    throw new Error(`Google Drive API error: ${driveResponse.status}`);
                }
                
                const folderData = await driveResponse.json();
                let foundFolder = folderData.files.filter(file => file.mimeType.startsWith('application/')).find(item => item.name === projectId);
                
                if (foundFolder) {
                    folderId = foundFolder.id;
                    query = encodeURIComponent(`'${folderId}' in parents and trashed=false`);
                    driveResponse = await fetch(
                        `https://www.googleapis.com/drive/v3/files?q=${query}&fields=files(id,name,mimeType)&key=${apiKey}`
                    );
                    
                    const fileData = await driveResponse.json();
                    const ids = fileData.files
                        .filter(file => file.mimeType.startsWith('image/'))
                        .map(file => file.id);
                    
                    setFileIds(ids);
                    const thumbnailUrls = ids.map(id => getThumbnailUrl(id));
                    setImages(thumbnailUrls);
                }
            } catch (error) {
                console.error("Error loading images:", error);
                
                setImages([]);
            } finally {
                setLoading(false);
            }
        };
        
        loadImages();
        setCurrentImageIndex(0);
        setViewMode('thumbnail');
    }, [projectId]);

    const toggleViewMode = () => {
        if (viewMode === 'thumbnail') {
            setViewMode('highres');
            setHighResImages([]);
            setLoading(true);
            const highResUrls = fileIds.map(id => getDirectDownloadUrl(id));
            setHighResImages(highResUrls);
            setLoading(false);
        } else {
            setViewMode('thumbnail');
            
            setImages([]);
            setLoading(true);
            const thumbnailUrls = fileIds.map(id => getThumbnailUrl(id));
            setImages(thumbnailUrls);
            setLoading(false);
        }
    };

    const nextImage = () => {
        if(viewMode === 'highres')
            toggleViewMode();
        setCurrentImageIndex((prevIndex) => 
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevImage = () => {
        if(viewMode === 'highres')
            toggleViewMode();
        setCurrentImageIndex((prevIndex) => 
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    if (loading) {
        return <div className="carousel-loading">Loading images...</div>;
    }

    if (images.length === 0) {
        return <div className="carousel-empty">No images available</div>;
    }
    const addDefaultImg = ev => {
        // ev.target.src = images[currentImageIndex]
        ev.target.src = 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
     }
    return (
        <div className="carousel">
            <button 
                className="carousel-button prev" 
                onClick={prevImage}
                aria-label="Previous image"
            >
                &lt;
            </button>
            
            <div className="carousel-image-container">
                <img 
                    src={viewMode === "thumbnail" ? images[currentImageIndex] : highResImages[currentImageIndex]} 
                    alt={`Project ${projectId} - ${currentImageIndex + 1}`} 
                    className="carousel-image"
                    onClick={toggleViewMode}
                    onError={(e) => addDefaultImg}
                    style={{
                        width: '100%',
                        height: 'auto'
                    }}
                />
                
                <div className="carousel-counter">
                    {currentImageIndex + 1} / {images.length}
                    {viewMode === 'thumbnail' && (
                        <span className="image-quality-indicator"> [SD](Click Image for HD)</span>
                    )}
                    {viewMode === 'highres' && (
                        <span className="image-quality-indicator"> [HD](Click Image for SD)</span>
                    )}
                </div>
            </div>
            
            <button 
                className="carousel-button next" 
                onClick={nextImage}
                aria-label="Next image"
            >
                &gt;
            </button>
        </div>
    );
};



export default ImageCarousel;